import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography, Grid, units } from '@ha/dsl';
import { useIntl } from 'ha/i18n';
import StudentResidence from 'ha/custom-icons/graduate.svg';

const useStyles = makeStyles()(theme => ({
  tag: {
    padding: units.yx(0.25, 0.2),
    paddingLeft: units.rem(1),
    borderTopLeftRadius: units.pxToRem(4),
  },
  tagSolid: {
    color: theme.palette.common.white,
    background: 'rgba(45, 70, 88, 0.7)',
    width: 200,
    fontWeight: 'bold',
    '&:after': {
      transform: 'skew(-30deg, 0deg) translateX(-50%)',
    },
  },
  tagWithShadow: {
    color: theme.palette.common.white,
    position: 'absolute',
    fontWeight: 'bold',
    bottom: 0,
    height: units.rem(2),
    background:
      'linear-gradient(90deg, rgba(45, 70, 88, 0.7) 0%, rgba(45, 70, 88, 0.7) 49.48%, rgba(45, 70, 88, 0) 100%)',
    width: units.rem(15),
    marginLeft: units.rem(-1),
    zIndex: 2,
  },
  text: {
    color: theme.palette.common.white,
    flex: 1,
  },
  icon: {
    paddingRight: units.rem(0.5),
  },
}));

interface Props {
  withShadow?: boolean;
}

const StudentResidenceNoticeTag: React.FC<Props> = ({ withShadow }) => {
  const { classes } = useStyles();
  const { T } = useIntl();
  return (
    <Grid
      item
      container
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      data-test-locator="StudentResidenceTag"
      className={`${classes.tag} ${
        withShadow ? classes.tagWithShadow : classes.tagSolid
      }`}
    >
      <StudentResidence className={classes.icon} />
      <Typography.Paragraph className={classes.text}>
        {T('student_accommodation.search_page.label')}
      </Typography.Paragraph>
    </Grid>
  );
};

export { StudentResidenceNoticeTag };
